import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes'
import { PageTitle } from '@src/api/common/PageTitleType'

const Breadcrumbs: Array<BreadcrumbItem> = [
    {
        title: 'Admin',
        isLink: false
    },
    { title: 'Technology', isLink: false },
]

const Title: PageTitle = {
    title: 'Technology',
}

export { Breadcrumbs, Title };